import { Directive, Input } from '@angular/core';

@Directive()
export class BaseStyleClassesDirective {
  @Input() borderClass = 'border-dark';
  @Input() backgroundClass = 'bg-dark text-white';
  @Input() buttonClass = 'btn-dark';
}
